var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Heading, Box, SimpleGrid, Spinner, IconButton } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import ArticleLink from './ArticleLink';
import InfiniteScroll from 'react-infinite-scroller';
import { ArrowUpIcon } from '@chakra-ui/icons';
var News = function (props) {
    var _a = useState([]), articles = _a[0], setArticles = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(true), isMore = _c[0], setIsMore = _c[1];
    function fetchArticles(start, limit) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, fetch("https://api.spaceflightnewsapi.net/v3/articles?_limit=".concat(limit.toString(), "&_start=").concat(start.toString()))
                        .then(function (response) {
                        if (!response.ok) {
                            throw new Error(response.statusText);
                        }
                        return response.json();
                    })
                        .then(function (data) {
                        return data;
                    })];
            });
        });
    }
    function fetchMore() {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        fetchArticles(articles.length, 10).then(function (result) {
            console.log(result);
            if (result.length === 0) {
                setIsMore(false);
                return;
            }
            var data = articles;
            result.map(function (article) {
                data.push(article);
            });
            setArticles(data);
            setIsLoading(false);
        });
    }
    useEffect(function () {
        setIsLoading(true);
        fetchArticles(1, 10).then(function (result) {
            console.log(typeof result[0]);
            setArticles(result);
            setIsLoading(false);
        });
    }, []);
    return (_jsxs(Box, __assign({ mx: ['3rem', '5rem', '8rem', '10rem', '15rem'], mt: "8%", minH: '100vh' }, { children: [_jsx(Heading, __assign({ className: "title", textTransform: 'uppercase', fontSize: ['2rem', '3rem', '5rem', '7rem'], id: "news" }, { children: "News" })), _jsx(InfiniteScroll, __assign({ pageStart: 0, loadMore: fetchMore, hasMore: true, loader: _jsx(Spinner, {}) }, { children: _jsx(SimpleGrid, __assign({ columns: [1, 1, 1, 2, 2, 3], gap: 5, width: '90%', gridRowGap: 10, my: 5 }, { children: articles.map(function (article, index) { return (_jsx(ArticleLink, { heading: article.title, url: article.url, description: article.summary, time: article.publishedAt }, article.title)); }) })) })), _jsx(IconButton, { as: 'a', "aria-label": "Back to Top", icon: _jsx(ArrowUpIcon, {}), position: 'fixed', bottom: "5", right: '5', size: "lg", borderRadius: '100%', colorScheme: "purple", variant: 'solid', href: "#news" })] })));
};
export default News;
